import React from "react";
import { Input } from "antd";
import { useContext } from "react";
import { WithdrawModalsContext } from "../context/WithdrawModalContext";
import errorText from "Shared/constants/errors.json";

export const CreateIbanAccount = () => {
	const { onChangeWalletData, newWalletData, errors } = useContext(WithdrawModalsContext);

	const onChangeMethodValue = (e) => onChangeWalletData("iban", e.target.value);

	return (
		<>
			<div className="withdraw-modal__row">
				<div className="withdraw-modal__row-label">IBAN</div>
				<Input onChange={onChangeMethodValue} value={newWalletData?.iban} status={errors.iban ? "error" : ""} />
				{errors.iban && (
					<div className="error-messages">
						<div className="error-messages__message">{errorText[errors.iban]}</div>
					</div>
				)}
				{errors?.alredy_registered && (
					<div className="error-messages">
						<div className="error-messages__message">{errors?.alredy_registered}</div>
					</div>
				)}
			</div>
		</>
	);
};
